import { TimeEntryExpenseData } from './time-entry-expense-data';
import { TimeEntryRateData } from './time-entry-rate-data';
import { TimeEntryData } from './time-entry-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class TimeEntryStaffData {
  StaffId: string;
  ContactName: string;
  Deleted: boolean;
  Expenses: TimeEntryExpenseData[];
  Rates: TimeEntryRateData[];
  TimeEntries: TimeEntryData[];
}


